import { render, staticRenderFns } from "./nearRegisterInfo.vue?vue&type=template&id=6ad1fc22"
import script from "./nearRegisterInfo.vue?vue&type=script&lang=js"
export * from "./nearRegisterInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad1fc22')) {
      api.createRecord('6ad1fc22', component.options)
    } else {
      api.reload('6ad1fc22', component.options)
    }
    module.hot.accept("./nearRegisterInfo.vue?vue&type=template&id=6ad1fc22", function () {
      api.rerender('6ad1fc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/near/nearRegisterInfo.vue"
export default component.exports